export default "__VITE_ASSET__a9854f47__"